import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import { BrowserRouter } from "react-router-dom";
import AuthContextProvider from "./context/authContext";
const WEB_PUSH_PUBLIC_KEY = "BKvNbHgS5v8Zte52gho8pFEOgS0gG65hl6rCYaJhEd7ewl27DNzRFNn-M69H8Gw9dyVKK_bu9Q9TAe16Onl0nkA";


export const transition = { enter: { duration: 0.5 }, exit: { duration: 0.1 } };

const theme = extendTheme({
  colors: {
    //AAHERA Colors
    primary: "#1a7e64",
    primaryDark: "#084131",
    // primary: "#1D8C23",
    // primaryDark: "#1D8C23",
    primaryLight: "#1a7e64c9",
    secondary: "#FC7067",
    bgColor: "#EFE2FF",
    bgColorLight: "#F9F9F9",
    lightPink: "#FEE8E7",
  },

  styles: {
    global: {
      body: {
        fontFamily: "Raleway, sans-serif",
        fontSize: "14px",
        // color: "#1D8C23",
        color: "#1a7e64",
        fontWeight: 500,
      },
    },
  },
});

// Register service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', function() {
    navigator.serviceWorker.register('/firebase-messaging-sw.js')
      .then(function(registration) {
        console.log('Service Worker registration successful with scope: ', registration.scope);
      }, function(err) {
        console.log('Service Worker registration failed: ', err);
      });
  });
}

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthContextProvider>
        <ChakraProvider theme={theme}>
          <App />
        </ChakraProvider>
      </AuthContextProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// ServiceWorkerRegistration.register();
